export default {
  white: "#ffffff",
  black: "#191a17",
  grey50: "#f3f3f1",
  red300: "#FF4E78",
  green300: "#2BE9A4",
  purple300: "#9382FF",
  teal300: "#41D2D2",
  yellow300: "#EAFC78",
};
